'use strict';
require('../../modules/es.object.keys');
var path = require('../../internals/path');

module.exports = path.Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/object/keys.js
// module id = 341
// module chunks = 0